const CoupleHeading = () => {
    return (
        <div className={`couple-section-message`}>
            <h2>
               We invite you to grace this joyous occasion with your presence.
            </h2>
        </div>
    )
}

export default CoupleHeading;